var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "slider-built-cottages__item" }, [
    _c("a", { attrs: { href: _vm.item.DETAIL_PAGE_URL } }, [
      _c(
        "div",
        { staticClass: "cottages__images-img" },
        [
          _c("slider-photo", {
            attrs: {
              item: _vm.item,
              "max-height": 174,
              "is-playing": _vm.isPlaying,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "built-cottage__content-wrapper" }, [
        _c("div", { staticClass: "built-cottage__content" }, [
          _c("p", { staticClass: "built-cottage__content-title" }, [
            _c("a", { attrs: { href: _vm.item.DETAIL_PAGE_URL } }, [
              _vm._v(_vm._s(_vm.item.NAME)),
            ]),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "projects-home__note" }, [
            _vm._v(
              "\n                                            Построим на выбраном вами участке\n                                        "
            ),
          ]),
          _vm._v(" "),
          _vm.checkPrice(_vm.item)
            ? _c("p", { staticClass: "built-cottage__price" }, [
                _vm._v(
                  "от " +
                    _vm._s(
                      _vm._f("currency")(
                        parseInt(_vm.item.PROPS.PRICE[0].VALUE)
                      )
                    )
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "built-cottage__details" }, [
          _c("div", { staticClass: "built-cottage__detail" }, [
            _c("p", { staticClass: "built-cottage__details-name" }, [
              _vm._v("Спальни:"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "built-cottage__details-count" }, [
              _vm._v(_vm._s(_vm.item.PROPS.ROOMS[0].VALUE)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "built-cottage__detail" }, [
            _c("p", { staticClass: "built-cottage__details-name" }, [
              _vm._v("Санузлов:"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "built-cottage__details-count" }, [
              _vm._v(_vm._s(_vm.item.PROPS.BATHROOMS[0].VALUE)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "built-cottage__detail" }, [
            _c("p", { staticClass: "built-cottage__details-name" }, [
              _vm._v("Этажей:"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "built-cottage__details-count" }, [
              _vm._v(_vm._s(_vm.item.PROPS.FLOORS[0].VALUE)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "built-cottage__detail" }, [
            _c("p", { staticClass: "built-cottage__details-name" }, [
              _vm._v("Площадь:"),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "built-cottage__details-count" }, [
              _vm._v(_vm._s(_vm.item.PROPS.M2[0].VALUE) + " м²"),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "built-cottage__info" }, [
        _c("p", { staticClass: "project-check" }, [_vm._v("Проект дома")]),
        _vm._v(" "),
        _c("div", { staticClass: "house-icons" }, [
          _c("button", { staticClass: "house-icon__btn" }, [
            _c("img", {
              staticClass:
                "house-icon__img house-icon__img-add house-icon-compare-cor",
              attrs: {
                src: _vm.getPath("icone-favourite-add.svg"),
                alt: "Icon",
              },
            }),
          ]),
          _vm._v(" "),
          _c("button", { staticClass: "house-icon__btn" }, [
            _c("img", {
              staticClass: "house-icon__img",
              attrs: { src: _vm.getPath("icon-heart.svg"), alt: "Icon" },
            }),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }